module.exports = __webpack_public_path__ + "img/snapchatLoginImg.4e922c5f.svg";